class ListFilter {
  constructor(params) {
    this.list = params.list;
    this.items = params.items;
    this.itemsObjs = this.items.map(item => {
      return {
        element: item,
        filters: JSON.parse(item.dataset.listFilter.replaceAll("'", '"')), // Assumes a "data-filter"-attribute with filter string.
      };
    });
    this.summaryCurrent = params.summaryCurrent;
    this.summaryTotal = params.summaryTotal;
    this.filters = params.filters; // INPUT[type="checkbox"] or INPUT[type="radio"] with attribute "value" (possibly matching string in list item "data-filter"-array) are assumed
    this.filtersAll = params.filtersAll;
    this.filtersAllContainer = this.filtersAll.parentNode; // TODO: Remove bias towards markup of this.filtersAll
    this.activeFilters = this.useCheckboxLogic
      ? this.getActiveFilters()
      : this.getFiltersValues();
    this.useCheckboxLogic = this.filters[0].getAttribute('type') === 'checkbox'; // Determine if to use 'checkbox' or 'radio' logic.
    this.uniqueStr = `${Math.floor(
      Math.random() * Math.floor(Math.random() * Date.now())
    )}`;
  }

  init() {
    this.eventBinding();
    this.addAttributes();
    this.updateList();
    if (this.summaryTotal) this.summaryTotal.innerHTML = this.items.length;
    this.updateSummary(this.items.length);
  }

  destroy() {
    this.eventUnbinding();
    this.removeAttributes();
  }

  eventBinding() {
    this.filters.forEach(filter => {
      filter.addEventListener('click', this.filterClickHandler);
    });

    if (this.useCheckboxLogic) {
      // If checkbox logic 'all' option equals a toggle of all filter checkboxes.
      this.filtersAllContainer.addEventListener('click', this.toggleFiltersAll);
      return;
    }

    // If radio logic 'all' option equals a reset of all filter radios.
    this.filtersAllContainer.addEventListener('click', this.resetFiltersAll);
  }

  eventUnbinding() {}

  addAttributes() {
    if (!this.list.getAttribute('id'))
      this.list.setAttribute('id', `list-filter-list-${this.uniqueStr}`);
    this.filtersAll.setAttribute(
      'aria-controls',
      this.filters.map(filter => filter.id).join(' ')
    );
    this.filtersAll.setAttribute('aria-checked', true);
    this.filters.map(filter =>
      filter.setAttribute('aria-controls', this.list.id)
    );
  }

  removeAttributes() {}

  getActiveFilters = () => {
    return this.filters
      .filter(filter => filter.checked)
      .map(filter => filter.value);
  };

  getFiltersValues = () => {
    return this.filters.map(filter => filter.value);
  };

  updateList = e => {
    const input = e?.target;
    const filter = input?.value;
    const isChecked = input?.checked;
    let visibleItems = 0;

    // Update activeFilters
    if (filter && !this.useCheckboxLogic) {
      // If is radio logic and a filter was clicked clear up checked filter (since with radios there can only be one checked at a time).
      this.filters.map(input => input.removeAttribute('checked'));
      this.activeFilters = [];
    }
    if (filter) input.setAttribute('checked', isChecked);
    if (filter && isChecked) this.activeFilters.push(filter);
    if (filter && !isChecked)
      this.activeFilters = this.activeFilters.filter(item => item !== filter);
    if (!filter)
      // If no filter was clicked (but the 'all' option) collect current filter situation
      this.activeFilters = this.useCheckboxLogic
        ? this.getActiveFilters() // In checkbox logic collect all checked ('all' equals a toggle).
        : this.getFiltersValues(); // In radio logic assume all clicked or rather unchecked/undefined ('all' equals a reset).

    // Handle display of items
    this.itemsObjs.forEach(itemObj => {
      let isVisible = false;

      this.activeFilters.forEach(activeFilter => {
        if (itemObj.filters.includes(activeFilter)) {
          isVisible = true;
        }
      });

      if (isVisible) {
        itemObj.element.style.display = '';
        visibleItems++;
        return;
      }

      itemObj.element.style.display = 'none';
    });

    // In checkbox logic: if nothing's checked display:none all (since 'all' option equals a toggle)
    if (this.useCheckboxLogic && this.activeFilters.length === 0)
      this.itemsObjs.forEach(itemObj => {
        itemObj.element.style.display = 'none';
      });

    this.updateSummary(visibleItems);
  };

  toggleFiltersAll = e => {
    const checked = !(this.filtersAll.getAttribute('aria-checked') === 'true');
    this.filtersAll.setAttribute('aria-checked', checked);

    this.filters.forEach(filter => {
      filter.checked = checked;
      filter.setAttribute('checked', checked);
    });
    this.updateList();
    this.updateFiltersAll();
  };

  resetFiltersAll = e => {
    const checked = true;
    this.filtersAll.setAttribute('aria-checked', checked);

    this.filters.forEach(filter => {
      if (this.useCheckboxLogic) {
        // In checkbox logic default: all filters are checked.
        filter.checked = checked;
        filter.setAttribute('checked', checked);
        return;
      }

      // In radio logic default: all filters are unchecked.
      filter.checked = false;
      filter.removeAttribute('checked');
    });
    this.updateList();
    this.updateFiltersAll();
  };

  updateFiltersAll = () => {
    if (this.activeFilters.length === 0) {
      this.filtersAll.setAttribute('aria-checked', false);
      return;
    }
    if (this.activeFilters.length === this.filters.length) {
      this.filtersAll.setAttribute('aria-checked', true);
      return;
    }
    this.filtersAll.setAttribute('aria-checked', 'mixed');
  };

  filterClickHandler = e => {
    this.updateList(e);
    this.updateFiltersAll();
  };

  updateSummary = visibleItems => {
    if (this.summaryCurrent) this.summaryCurrent.innerHTML = visibleItems;
  };
}

// --- Create list filter ---
const filterLists = document.querySelectorAll('.list-filter-list');
const filterListInstances = [];

filterLists.forEach(list => {
  const formId = list.dataset.listFilterForm;
  const form = document.querySelector(`#${formId}`);
  const filters = Array.from(
    form.querySelectorAll('input[type="checkbox"], input[type="radio"]')
  );
  const items = Array.from(list.querySelectorAll('[data-list-filter]'));
  const summary = document.querySelector(
    `.list-filter-summary[data-list-filter-form='${formId}']`
  );
  const summaryCurrent = summary.querySelector('.list-filter-summary__count');
  const summaryTotal = summary.querySelector(
    '.list-filter-summary__count-total'
  );
  const filtersAll = form.querySelector('.list-filter-all');

  const filterListInstance = new ListFilter({
    list,
    items,
    summaryCurrent,
    summaryTotal,
    filters,
    filtersAll,
  });

  filterListInstance.init();
  filterListInstances.push(filterListInstance);
});
